import * as types from "../actionTypes/perfiosCompleteActionTypes"

const initialState = {
    perfios_complete_code:'',
    error: false,
}

export const PerfiosCompleteReducer = (
    state = initialState,
    action:any
) => {  
    switch (action.type) {
        case types.PERFIOS_COMPLETE_SUCCESS:
            return {
                ...state,
                perfios_complete_code: action.payload.code,
                error: false,
            };
        case types.PERFIOS_COMPLETE_RESET:
            return {
                ...state,
                perfios_complete_code: '',
                error: false
            };
        case types.PERFIOS_COMPLETE_ERROR:
            return {
                ...state,
                error: true,
            };
        default:
            return state
    }
}